import { render, staticRenderFns } from "./ViewImg.vue?vue&type=template&id=77260a7f&scoped=true&"
import script from "./ViewImg.vue?vue&type=script&lang=js&"
export * from "./ViewImg.vue?vue&type=script&lang=js&"
import style0 from "./ViewImg.vue?vue&type=style&index=0&id=77260a7f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77260a7f",
  null
  
)

export default component.exports